// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-c1903fc2]{display:inline-block;font-size:14px;line-height:50px;margin-left:8px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-c1903fc2]{color:#97a8be;cursor:text}", ""]);
// Exports
module.exports = exports;
